import { communityReviews } from '@/mocks/content';

export default function CommunitySection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
            Community
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
            Trusted by <span className="text-primary-600">50,000+</span> Users
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {communityReviews.map((review, index) => (
            <div
              key={review.handle}
              className={`bg-white rounded-lg p-5 border border-background-200/70 ${
                index % 2 === 1 ? 'md:mt-8' : ''
              }`}
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="font-heading text-primary-600 font-bold text-sm">
                    {review.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{review.name}</p>
                  <p className="text-xs text-foreground-400">{review.handle}</p>
                </div>
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed italic">
                &ldquo;{review.review}&rdquo;
              </p>
              <div className="flex items-center gap-1 mt-3">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-primary-400 text-xs"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}